import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../../../style/theme';
import { colors } from '../../../../style/colors';

interface StyleProps {
  withUnlimitedCredits?: boolean;
}

export const useStyles = makeStyles<ITheme, StyleProps>((theme) => ({
  mainContainer: {
    [theme.breakpoints.down('xs')]: {
      paddingTop: 0,
      display: 'flex',
      flexDirection: 'column',
      placeContent: 'center',
      placeItems: 'flex-start',
    },
  },
  tabs: {
    [theme.breakpoints.down('xs')]: {
      maxWidth: '320px',
    },
  },
  toastsSection: {
    display: 'inline-flex',
  },
  recommendationContainer: {
    paddingLeft: 24,
    paddingRight: 24,
    paddingBottom: 40,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  bottomContainer: {
    paddingLeft: 24,
    paddingRight: 24,
  },
  MuiBox: {
    margin: 0,
    padding: 0,
  },
  offeringListWrapper: {
    '@media (min-height: 1000px)': {
      minHeight: 1000,
    },
  },
  offeringSection: {
    [theme.breakpoints.down(780)]: {
      display: 'block',
    },
    paddingBottom: 48,
    display: 'flex',
    flexWrap: 'wrap',
    gridTemplateColumns: '1fr 1fr 1fr',
    [theme.breakpoints.up(1300)]: {
      maxWidth: 1200,
    },
    alignItems: 'flex-end',
  },
  offering: {
    paddingRight: 24,
    paddingBottom: 24,
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
      paddingBottom: 0,
    },
  },
  tabsWrapper: {
    borderBottom: 1,
    borderColor: 'divider',
    width: '100%',
  },
  availableTopicCard: {
    position: 'relative',
    padding: 0,
    paddingRight: theme.spacing(2),
    boxShadow: '0 8 24 rgba(205, 205, 205, 0.24)',
    borderRadius: 12,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 360,
    },
  },
  availableTopicImage: {
    display: 'inline-block',
    verticalAlign: 'middle',
  },
  availableTopicText: {
    display: 'inline-block',
    verticalAlign: 'middle',
  },
  availableTopicLink: {
    textDecoration: 'none',
  },
  availableTopicType: {
    maxWidth: 164,
    [theme.breakpoints.up('sm')]: {
      maxWidth: 196,
    },
  },
  availableTopicTitle: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 700,
    maxWidth: 164,
    [theme.breakpoints.up('sm')]: {
      maxWidth: 196,
    },
  },
  availableTopicArrow: {
    position: 'absolute',
    right: theme.spacing(2),
    bottom: theme.spacing(2),
  },
  mainCard: {
    height: '440px',
    minWidth: '437px',
    display: 'flex',
    flexDirection: 'column',
    placeContent: 'space-between',
    padding: theme.spacing(5),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(3),
    },
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingBottom: theme.spacing(2),
  },
  submitButton: {
    width: '100%',
    borderWidth: 2,
    '&:hover': {
      borderWidth: 2,
    },
    marginTop: '24px',
  },
  loadingBox: {
    display: 'flex',
    flex: 1,
    height: '30vh',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  upcomingEventTitle: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  tabLabel: {
    fontSize: '16px',
    lineHeight: '21px',
    fontWeight: 'bold',
    color: colors.darkestBlue,
  },
  dateDivider: {
    color: colors.darkGray,
    paddingBottom: 16,
  },
  divider: {
    height: '1px',
    backgroundColor: colors.lightGray,
    margin: '40px 0 16px 0',
  },
  mentorRecommendation: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
    },
  },
  upcomingEventContainer: {
    marginRight: 24,
    marginBottom: 16,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginRight: 0,
    },
  },
  descriptionWrapper: {
    maxWidth: 718,
    padding: '16px 0',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  learnMore: {
    color: colors.darkestBlue,
    fontWeight: 700,
    cursor: 'pointer',
  },
}));
